export const makeAnnotationEditors = (
  self: CF.API.Annotations.Annotation,
): {
  editBbox: ({ bbox }: { bbox: CF.API.BoundingBox }) => typeof self;
  editPolygon: ({ points }: { points: CF.API.Polygon['points'] }) => typeof self;
} => {
  return {
    editPolygon: ({ points }) => {
      if (!self.data || !('regions' in self.data)) return self;

      if (self.data.regions && self.data.regions[0]) {
        const region = self.data.regions[0];

        const updated = {
          ...self,
          data: {
            ...self.data,
            regions: [
              {
                ...region,
                id: undefined as unknown as string,
                region_info: {
                  polygon: { points },
                },
              },
            ],
          },
        };

        return updated;
      }

      return self;
    },
    editBbox: ({ bbox }: { bbox: CF.API.BoundingBox }) => {
      if (!self.data || !('regions' in self.data)) return self;
      if (self.data.regions && self.data.regions[0]) {
        const region = self.data.regions[0];

        const updated = {
          ...self,
          data: {
            ...self.data,
            regions: [
              {
                ...region,
                id: undefined as unknown as string,
                region_info: {
                  bounding_box: bbox,
                },
              },
            ],
          },
        };

        return updated;
      }

      return self;
    },
  };
};
